import theme from '../../../theme/news12'

import css from 'styled-jsx/css'

export default css.global`
  .newsletter-page-container {
    max-width: 800px;
    margin: 0 auto;  
    padding: 24px;
  }
  
  .newsletter-page-container h1 {
    margin-bottom: 36px;
  } 
  
  .description {
    font-size: 1em;
    font-weight: 300;
    line-height: 1.5em;
    margin: 0 0 15px 26px;
  }
  
  .email-container {
    height: 80px;
    margin-bottom: 15px;
  }
    
  .title {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 17px;
  }
  
  .input {
    width: 40%;
    height: 17px;
    margin-left: 10px;
    border: 1px solid ${theme.colors.lightGray2};
    border-radius: 4px;
    padding: 10px 12px;
    font-family: Graphik;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: ${theme.colors.codGray};
    caret-color: ${theme.colors.lightBlue};
    line-height: 24px;
    transition: 0.2s ease-in-out;
    -webkit-appearance: none !important;
  }
  
  .input:focus {
    outline: none;
    border: 1px solid ${theme.colors.codGray};
    transition: 0.2s ease-in-out;
  }
  
  .list-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 1.2em;
    margin-left: 10px;
  }
  
  .list-item {
    margin: 0 10px 20px 10px;
  }
  
  .helper-text {
    margin-top: 5px;
    margin-left: 15px;
    font-weight: 400;
    font-size: 13px;
    color: ${theme.colors.alertRed}
  }
  
  .checkbox {
    width: 17px;
    height: 17px;
    float: left;
    margin: 0;
    cursor: pointer;
  }
  
  .signup-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .signup-button {
    border:none;
    width: 156px;
    height: 56px;
    color: white;
    background: ${theme.colors.lightBlue};
    cursor: pointer;
    border-radius: 4px;
  }
  
  .signup-button:hover {
    background: ${theme.colors.blueHover};
  }
  
  .signup-button-text {
    font-size: 18px;
    line-height: 1.5em;
  }
  
  .subscriptionMessage {
    margin-top: 15px;
    color: ${theme.colors.lightBlue};
    font-family: Graphik;
    font-weight: 400;
    font-size: 18px;
  }
  
  .subscriptionMessage.error {
    color: ${theme.colors.alertRed};
  }
`
